export var themeColor = '#4A0A4D';
export var lightThemeColor = '#4A0A4D';
export var error = '#FF2A2A';
export var brightThemeColor = '#f4d8f6';
export var fadedBrightThemeColor = '#BE4BC4';
export var markerRed = '#AF1419';
export var linkBlue = '#15c';
export var darkGray = '#707070';
export var boxShadowGray = '#00000029';
export var tooltipGray = '#A7A7A7';
export var lightGray = "#e6e6e6";
// export const lightThemeColor = '#56B7C9';
// export const green = '#256230';
// export const lightGreen = '#C4E945';
// export const brightGreen = '#30B422';
// export const fadedBrightGreen = '#30B4221A';
//# sourceMappingURL=colors.js.map